import React from 'react';

function MetricCard({ icon, title, value, variant = 'primary' }) {
    const iconContainerClass = `d-flex align-items-center justify-content-center me-3 rounded-circle bg-${variant}-subtle`;
    const iconClass = `text-${variant}`;

    return (
        <div className="card h-100 shadow-sm border-0">
            <div className="card-body">
                <div className="d-flex align-items-center">
                    <div className={iconContainerClass} style={{ width: '50px', height: '50px' }}>
                        <span className={iconClass}>
                            {React.cloneElement(icon, { size: 24 })}
                        </span>
                    </div>
                    <div>
                        <h4 className="fw-bold mb-0">{value}</h4>
                        <p className="text-muted mb-0">{title}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MetricCard;